import { render, staticRenderFns } from "./FileImageQuestion.vue?vue&type=template&id=54de8a27&scoped=true&"
import script from "./FileImageQuestion.vue?vue&type=script&lang=js&"
export * from "./FileImageQuestion.vue?vue&type=script&lang=js&"
import style0 from "./FileImageQuestion.vue?vue&type=style&index=0&id=54de8a27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54de8a27",
  null
  
)

export default component.exports